import React from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import logoMedical from "../../assets/logo-medical.png";
import hand from "../../assets/mano.png";
import { useGameTexts } from "../../hooks/useGameTexts";
import { SERVER_URL } from "../../api";
import { useLang } from "../../translations/i18n";
import { ROUTES } from "../../utils/constants";
import { getScenarioByScreen, handleNavigate } from "../../utils/helpers";
import { modalQuestionInfo } from "../../utils/logger";

function buildImageUrl(value, fallback) {
	if (!value || typeof value !== "string") return fallback;
	if (value.startsWith("http")) return value;
	return `${SERVER_URL.replace(/\/$/, "")}/${value.replace(/^\//, "")}`;
}

function Scenario3Intro({ intl }) {
	const lang = useLang();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const group = useSelector((state) => state.group);
	const { texts, ready } = useGameTexts(group?.game);

	const title = texts["scenario3.intro.title"] ?? "";
	const content = texts["scenario3.intro.content"] ?? "";
	const imageUrl = texts["scenario3.intro.image"] ? buildImageUrl(texts["scenario3.intro.image"], null) : null;
	const modalTitle = texts["scenario3.intro.modalTitle"] ?? "";
	const modalList = texts["scenario3.intro.modalList"] ?? "";
	const modalImageUrl = texts["scenario3.intro.modalImage"] ? buildImageUrl(texts["scenario3.intro.modalImage"], null) : null;

	const questionInfoHtml = `<div class="d-flex flex-column align-items-start justify-content-center txt-turquoise"><div class="txt-turquoise bold txt20 text-center">${modalTitle || ""}</div><div class="d-flex justify-content-center w-100 mt-4">${modalImageUrl ? `<img src="${modalImageUrl}" alt="" />` : "<div style=\"width:100%;height:200px;background:#e0e0e0;border-radius:8px\"></div>"}</div><div class="d-flex align-items-start mt-4"><img width="10%" src="${hand}" alt="" /><ul>${modalList || ""}</ul></div></div>`;

	return (
		<div className="h-100">
			<div className="container-fluid bg-internas">
				<div style={{ paddingTop: "6vh", paddingLeft: "6vh" }}>
					<img width={240} src={logoMedical} />
				</div>
				<div
					style={{ paddingLeft: "6vh", minHeight: "60vh" }}
					className="row d-flex justify-content-start align-items-start mt-5 pt-5"
				>
					{!ready ? (
						<div className="col-4 txtWhite d-flex align-items-center">
							<div className="txtWhite">Cargando...</div>
						</div>
					) : (
					<>
					<div className="col-3 txtWhite">
						<div
							className="txtWhite txt20"
							style={{ letterSpacing: 3 }}
						>
							ESCENARIO 3
						</div>
						<div
							className="txtWhite txt30 bold mt-3"
							style={{ letterSpacing: 3, lineHeight: "30px" }}
						>
							{title && title.indexOf("<") >= 0 ? <span dangerouslySetInnerHTML={{ __html: title }} /> : title}
						</div>
						<div className="mt-4">
							{content && content.indexOf("<") >= 0 ? <span dangerouslySetInnerHTML={{ __html: content }} /> : content}
						</div>
					</div>
					<div
						className="d-flex justify-content-end"
						style={{
							position: "absolute",
							right: "0%",
							bottom: "15%",
						}}
					>
						<div
							className="col-9 d-flex justify-content-end"
							onClick={() =>
								modalQuestionInfo({ html: questionInfoHtml }).then(
									(res) => {
										if (res.isConfirmed)
											handleNavigate({
												group: group,
												navigate: navigate,
												dispatch: dispatch,
												navigateTo: ROUTES.SCENARIO3,
												scenarioNum:
													getScenarioByScreen(
														ROUTES.SCENARIO3
													),
											});
									}
								)
							}
						>
							{imageUrl ? (
								<img height={480} src={imageUrl} alt="" />
							) : (
								<div style={{ height: 480, width: 360, background: "#e0e0e0", borderRadius: 8 }} aria-hidden />
							)}
						</div>
					</div>
					</>
					)}
				</div>
			</div>
		</div>
	);
}

export default injectIntl(Scenario3Intro);
